<template>

<div>
    <LargeHero :heroLevel="heroLevel">
        <span class="head-line-one">{{ heroLevel }} Degree</span> <span class="head-line-two">Classification Calculator</span>
    </LargeHero>
    
    <Disclaimer/>
    
    <!-- <Menu @menu = "changeMenu" /> -->
<!-- 
    <section class="container section-large option-container">

    </section> -->
    
    <!-- <section v-show="component === 'LevelSix'" class="container option-container">
        <div class="options">
            <div class="">
                <q-checkbox
                label="I have passed fewer than 120 Man Met credits at level 5"
                aria-label="passed fewer than 120 Man Met credits at level 5 toggle"
                v-model="lessThanOneTwentyToggle"
                color="#002F6C"
                size="lg"
                @click="isCalc"
                />
            </div>
        </div>
    </section> -->
    
    <section id="start"  class="container relative-position section-large">
            <!-- <div class="option-container mbm">
                <div class="options">
                    <q-checkbox
                    label="I have passed fewer than 120 Man Met credits at level 5"
                    aria-label="passed fewer than 120 Man Met credits at level 5 toggle"
                    v-model="lessThanOneTwentyToggle"
                    color="#002F6C"
                    size="lg"
                    class=""
                    />
                </div>
            </div> -->
            <div v-intersection.once="onIntersection" class="">
                        <LevelFiveAndSix
                        @SubmitUndergrad="handlerSubmitUndergrad"
                        :calculated="calculated"
                        />
            </div>
    </section>
    
    <Results
    :resultsClassOnOff="resultsClassOnOff"
    :weightedAvClassTitle="weightedAvClassTitle"
    :lessThanOneTwentyToggle="lessThanOneTwentyToggle"
    :levelSixFinalGrade="levelSixFinalGrade"
    :LvSixSeventyFivePercent="LvSixSeventyFivePercent"
    :LvSixOneHundredPercent="LvSixOneHundredPercent"
    :levelFiveFinalGrade="levelFiveFinalGrade"
    :LvFiveTwentyFivePercent="LvFiveTwentyFivePercent"
    :weightedAvClass="weightedAvClass"
    :methodOne="methodOne"
    :methodTwo="methodTwo"
    :circleScore = "circleScore"
    :methodSwitch = "methodSwitch"
    :finalScore = "finalScore"
    :postGradResults = "postGradResults"
    :component = "component"
    />
    
    <Footer/>

</div>

</template>

<script>
import { ref, computed } from 'vue'
import LargeHero from '@/components/LargeHero.vue'
import Footer from '@/components/Footer.vue'
import Menu from '@/components/Menu.vue'
import LevelFiveAndSix from '@/components/calculators/LevelFiveAndSix.vue'
import PgCert from '@/components/calculators/PgCert.vue'
import Masters from '@/components/calculators/Masters.vue'
import MasterOfArchitecture from '@/components/calculators/MasterOfArchitecture.vue'
import LevelSix from '@/components/calculators/LevelSix.vue'
import MasterOfLandscapeArchitecture from '@/components/calculators/MasterOfLandscapeArchitecture.vue'
import Results from '@/components/Results.vue'
import Disclaimer from '@/components/Disclaimer.vue'
import { useRouter } from 'vue-router'
import { scroll, useQuasar } from 'quasar'

export default {
components: { LargeHero, Footer, Disclaimer, Results, PgCert, Menu, LevelFiveAndSix, LevelSix, Masters, MasterOfLandscapeArchitecture, MasterOfArchitecture},

setup(props, context) {

///LEVEL FIVE VARIABLES
const LvFiveTwentyFivePercent = ref(0)
const levelFiveFinalGrade = ref(0)

///LEVEL SIX VARIABLES
const levelSixFinalGrade = ref(0)
const LvSixSeventyFivePercent = ref(0)
const LvSixOneHundredPercent = ref(0)

///LEVEL PG CERT VARIABLES
const passCredits = ref(0)
const meritClassCredits = ref(0)
const distinctionClassCredits = ref(0)
const PgCertFinalGrade = ref(0)
const LandscapeArchitectureFinalGrade = ref(0)


const firstClassCredits = ref([])
const secondOneClassCredits = ref([])
const secondTwoClassCredits = ref([])
const thirdClass = ref([])
const gradeSwitch = ref(false)

const methodOne = ref('Incalculable')
const methodTwo = ref('Incalculable')
const postGradResults = ref(false)
const weightedAvClass = ref(0)
const { getScrollTarget } = scroll
const visible = ref(true)
const weightedAvClassTitle = ref('Try again')
const router  = useRouter()
const resultsClassOnOff = ref(true) /// remember to turn this on to hide results
const sessionMemory = useQuasar()
const lessThanOneTwentyToggle = ref(false)
const calculated = ref(false)
const methodSwitch = ref(true)
const circleScore = ref(0)
const finalScore = ref(0)
const component = ref('LevelFiveAndSix')
let heroLevel = ref('Undergraduate')

const changeMenu = (menuItem, heroTitle) => {
        menuItem === 'LevelSix' ? component.value = LevelFiveAndSix : component.value = menuItem 
        menuItem === 'LevelSix' ? lessThanOneTwentyToggle.value = true : lessThanOneTwentyToggle.value = false
        heroTitle === "Postgraduate" ? postGradResults.value = true : postGradResults.value = false
        heroLevel.value = heroTitle
}

const visibleClassSix = computed(() => { 
    if(visible.value){
        return 'show-six'
    } else {
        return 'hide-six'
    }
})

const visibleClassFive = computed(() => { 
    if(visible.value) {
        return 'show-five'
    } else {
        return 'hide-five'
    }
})

const onIntersection = (entry) => {
    const mediaQuery = window.matchMedia('(min-width: 600px)')
    mediaQuery.matches ? visible.value = entry.isIntersecting : visible.value = true         
}



//////////////////////
///Result Calculations
/////////////////////

const handlerSubmitUndergrad = (lvFiveCredits, lvFiveMarks, lvFiveTotalCredits, lvSixCredits, lvSixMarks, lvSixTotalCredits, lessThanOneTwenty) => {
    
    // RESETS
    firstClassCredits.value = 0
    secondOneClassCredits.value = 0
    secondTwoClassCredits.value = 0
    thirdClass.value = 0
    gradeSwitch.value = false
    calculated.value = true

    lessThanOneTwentyToggle.value = lessThanOneTwenty

    // LEVEL FIVE FUNCTION

    /// Creating new array that replaces strings with numbers
    let LvFiveCreditsToNum = lvFiveCredits.map(i => Number(i))

    /// Multiplying each mark by related number of credits
    const lvFiveCreditMarkMultiplyer = LvFiveCreditsToNum.map((i, index) => { return  lvFiveMarks[index] * i})

    /// All of the values after multiplying each mark with related credit is added up here
    const lvFiveMultiplyerSum = lvFiveCreditMarkMultiplyer.reduce((previousValue, currentValue) => previousValue + currentValue);

    /// Divide by the total number of credits
    levelFiveFinalGrade.value =  lvFiveMultiplyerSum / lvFiveTotalCredits

    !levelFiveFinalGrade.value ? levelFiveFinalGrade.value = 0 : levelFiveFinalGrade.value = lvFiveMultiplyerSum / lvFiveTotalCredits

    /// Times Lv 5 by 25%
    LvFiveTwentyFivePercent.value = levelFiveFinalGrade.value * 0.25

    // LEVEL SIX FUNCTION

    /// Creating new array that replaces strings with numbers
    let LvSixCreditsToNum = lvSixCredits.map(i => Number(i))

    /// Multiplying each mark by related number of credits
    const lvSixCreditMarkMultiplyer = LvSixCreditsToNum.map((i, index) => { return  lvSixMarks[index] * i})

    LvSixCreditsToNum.forEach((item, index) => {
        if(lvSixMarks[index] >= 70) {
            return firstClassCredits.value =  Number(firstClassCredits.value += item)
        }
    })

    LvSixCreditsToNum.forEach((item, index) => {
        if(lvSixMarks[index] >= 60) {
            return  secondOneClassCredits.value =  Number(secondOneClassCredits.value += item)
        }
    })

    LvSixCreditsToNum.forEach((item, index) => {
        if(lvSixMarks[index] >= 50) {
            return  secondTwoClassCredits.value =  Number(secondTwoClassCredits.value += item)
        }
    })

    LvSixCreditsToNum.forEach((item, index) => {
        if(lvSixMarks[index] >= 40) {
            return thirdClass.value =  Number(thirdClass.value += item)
        }
    })

    /// All of the values after multiplying each mark with related credit is added up here
    const lvSixMultiplyerSum = lvSixCreditMarkMultiplyer.reduce((previousValue, currentValue) => previousValue + currentValue);

    //// Divide by the total number of credits
    levelSixFinalGrade.value =  lvSixMultiplyerSum / lvSixTotalCredits

    !levelSixFinalGrade.value ? levelSixFinalGrade.value = 0 : levelSixFinalGrade.value =  lvSixMultiplyerSum / lvSixTotalCredits

    //// Times Lv 6 by 75%
    LvSixSeventyFivePercent.value = levelSixFinalGrade.value * 0.75

    //// Times Lv 6 by 100%
    LvSixOneHundredPercent.value = levelSixFinalGrade.value * 1

    !LvSixSeventyFivePercent.value ? LvSixSeventyFivePercent.value = 0 : LvSixSeventyFivePercent.value = levelSixFinalGrade.value * 0.75

    weightedAvClass.value = LvFiveTwentyFivePercent.value + LvSixSeventyFivePercent.value

    !weightedAvClass.value ? weightedAvClass.value = 0 : weightedAvClass.value = LvFiveTwentyFivePercent.value + LvSixSeventyFivePercent.value

    ///CHOOSE((K9>=1)+(K9>=40)+(K9>=50)+(K9>=60)+(K9>=70),"Fail","Third","Class Two Division 2","Class Two Division 1","First Class")

    ///////FINAL  SCORE

    if ( lvFiveTotalCredits === 120 && lvSixTotalCredits === 120 && weightedAvClass.value >= levelSixFinalGrade.value ) {
        if(!lessThanOneTwenty) {
            if (weightedAvClass.value >= 40 && weightedAvClass.value < 50) {
                weightedAvClassTitle.value = 4
            } else if (weightedAvClass.value >= 50 && weightedAvClass.value < 60) {
                weightedAvClassTitle.value = 3
            } else if (weightedAvClass.value >= 60 && weightedAvClass.value < 70) {
                weightedAvClassTitle.value = 2
            } else if (weightedAvClass.value >= 70) {
                weightedAvClassTitle.value = 1
            } else  {
                weightedAvClassTitle.value = 'Incalculable';
            }
        } else {
            if ( levelSixFinalGrade.value >= 40 && levelSixFinalGrade.value < 50 ) {
                weightedAvClassTitle.value = 4
            } else if (levelSixFinalGrade.value >= 50 && levelSixFinalGrade.value < 60) {
                weightedAvClassTitle.value = 3
            } else if (levelSixFinalGrade.value >= 60 && levelSixFinalGrade.value < 70) {
                weightedAvClassTitle.value = 2
            } else if (levelSixFinalGrade.value >= 70) {
                weightedAvClassTitle.value = 1
            } else  {
                weightedAvClassTitle.value = 'Incalculable';
            }
        }
    } else {
        if( lvSixTotalCredits != 120 && weightedAvClassTitle.value != 'Incalculable' ) {
            weightedAvClassTitle.value = '120 credits required'
        } else if (levelSixFinalGrade.value >= 68 && firstClassCredits.value >= 60) {
            weightedAvClassTitle.value = 1
        } else if (levelSixFinalGrade.value >= 58 && secondOneClassCredits.value >= 60) {
            weightedAvClassTitle.value = 2
        } else if (levelSixFinalGrade.value >= 48 && secondTwoClassCredits.value >= 60) {
            weightedAvClassTitle.value = 3
        } else if (levelSixFinalGrade.value >= 40 && thirdClass.value >= 120) {
            weightedAvClassTitle.value = 4
        } else {
            weightedAvClassTitle.value = 'Incalculable'
        }
    }

    if (lvSixTotalCredits === 120 && lessThanOneTwenty === true &&  weightedAvClassTitle.value ===  'Incalculable') {
        if ( levelSixFinalGrade.value >= 40 && levelSixFinalGrade.value < 50 ) {
            weightedAvClassTitle.value = 4
        } else if (levelSixFinalGrade.value >= 50 && levelSixFinalGrade.value < 60) {
            weightedAvClassTitle.value = 3
        } else if (levelSixFinalGrade.value >= 60 && levelSixFinalGrade.value < 70) {
            weightedAvClassTitle.value = 2
        } else if (levelSixFinalGrade.value >= 70) {
            weightedAvClassTitle.value = 1
        } else  {
            weightedAvClassTitle.value = 'Incalculable';
        }
    }

    if ( weightedAvClassTitle.value === 'Incalculable' && weightedAvClass.value >= 40 && lvFiveTotalCredits === 120 && lvSixTotalCredits === 120 || weightedAvClassTitle.value === 'Incalculable' && weightedAvClass.value >= 40 && lvSixTotalCredits === 120 && lessThanOneTwenty === true ) {

        gradeSwitch.value = true

        if( lessThanOneTwenty === true ) {
            if ( lvSixTotalCredits != 120 ) {
                weightedAvClassTitle.value = '120 credits required'
            } else if ( levelSixFinalGrade.value >= 40 && levelSixFinalGrade.value < 50 ) {
                weightedAvClassTitle.value = 4
            } else if( levelSixFinalGrade.value >= 50 && levelSixFinalGrade.value < 60) {
                weightedAvClassTitle.value = 3
            } else if( levelSixFinalGrade.value >= 60 && levelSixFinalGrade.value < 70 ) {
                weightedAvClassTitle.value = 2
            } else if(levelSixFinalGrade.value >= 70) {
                weightedAvClassTitle.value = 1
            } else  {
                weightedAvClassTitle.value = 'Incalculable';
            } 
        } else {
            if ( lvSixTotalCredits  != 120 || lvFiveTotalCredits < 120 ) {
                weightedAvClassTitle.value = '120 credits required for level 5 & 6'
            } else if ( weightedAvClass.value >= 40 && weightedAvClass.value < 50 ) {
                weightedAvClassTitle.value = 4
            } else if( weightedAvClass.value >= 50 && weightedAvClass.value < 60) {
                weightedAvClassTitle.value = 3
            } else if( weightedAvClass.value >= 60 && weightedAvClass.value < 70 ) {
                weightedAvClassTitle.value = 2
            } else if(weightedAvClass.value >= 70) {
                weightedAvClassTitle.value = 1
            } else  {
                weightedAvClassTitle.value = 'Incalculable';
            } 
        }
    }

    if (lessThanOneTwenty === true) {
        if( lvSixTotalCredits != 120 ) {
            methodOne.value = '120 credits required'
        } else if( levelSixFinalGrade.value >= 40 && levelSixFinalGrade.value < 50 ) {
            methodOne.value = 4
        } else if( levelSixFinalGrade.value >= 50 && levelSixFinalGrade.value < 60) {
            methodOne.value = 3
        } else if( levelSixFinalGrade.value >= 60 && levelSixFinalGrade.value < 70 ) {
            methodOne.value = 2
        } else if(levelSixFinalGrade.value >= 70) {
            methodOne.value = 1
        } else  {
            methodOne.value = 'Incalculable';
        }
    } else { 
        if( lvSixTotalCredits != 120 || lvFiveTotalCredits != 120 ) {
            methodOne.value = '120 credits required for level 5 & 6'
        } else if( weightedAvClass.value >= 40 && weightedAvClass.value < 50 ) {
            methodOne.value = 4
        } else if( weightedAvClass.value >= 50 && weightedAvClass.value < 60) {
            methodOne.value = 3
        } else if( weightedAvClass.value >= 60 && weightedAvClass.value < 70 ) {
            methodOne.value = 2
        } else if(weightedAvClass.value >= 70) {
            methodOne.value = 1
        } else  {
            methodOne.value = 'Incalculable';
    }}  
     
    if( lvSixTotalCredits != 120 ) {
        methodTwo.value = '120 credits required'
    } else if( levelSixFinalGrade.value >= 68 && firstClassCredits.value >= 60 ) {
        methodTwo.value = 1
    } else if(levelSixFinalGrade.value >= 58 && secondOneClassCredits.value >= 60) {
        methodTwo.value  = 2
    } else if(levelSixFinalGrade.value >= 48 && secondTwoClassCredits.value >= 60) {
        methodTwo.value  = 3
    } else if(levelSixFinalGrade.value >= 40 && thirdClass.value >= 120) {
        methodTwo.value  = 4
    } else {
        methodTwo.value  = 'Incalculable'
    }

    if( lessThanOneTwenty === false ) {
        if( methodOne.value < weightedAvClassTitle.value ) {
            weightedAvClassTitle.value = methodOne.value
            methodSwitch.value = true 
        } else if ( methodOne.value === weightedAvClassTitle.value && weightedAvClass.value >= levelSixFinalGrade.    value && methodTwo.value >= weightedAvClassTitle.value || isNaN(methodTwo.value)  ) {
            weightedAvClassTitle.value = methodOne.value
            methodSwitch.value = true 
        } else {
            weightedAvClassTitle.value = methodTwo.value
            methodSwitch.value = false 
        }
    } else {
        if( methodOne.value < weightedAvClassTitle.value || methodTwo.value === 'Incalculable'  ) {
            weightedAvClassTitle.value = methodOne.value
            methodSwitch.value = true 
        } else {
            weightedAvClassTitle.value = methodTwo.value
            methodSwitch.value = false 
        }
    }

    resultsClassOnOff.value = false

    router.push({ hash: "#results" })


    if (weightedAvClassTitle.value === 1 || weightedAvClassTitle.value === 2 || weightedAvClassTitle.value === 3 || weightedAvClassTitle.value === 4) {
        if(weightedAvClassTitle.value === 1) {
            weightedAvClassTitle.value = 'First Class'
        } else if (weightedAvClassTitle.value === 2) {
            weightedAvClassTitle.value = '2:1'
        } else if (weightedAvClassTitle.value === 3) {
            weightedAvClassTitle.value = '2:2'
        } else {
            weightedAvClassTitle.value = 'Third Class'
        }
    }

    if (methodTwo.value === 1 || methodTwo.value === 2 || methodTwo.value === 3 || methodTwo.value === 4) {
        if(methodTwo.value === 1) {
            methodTwo.value = 'First Class'
        } else if (methodTwo.value === 2) {
            methodTwo.value = '2:1'
        } else if (methodTwo.value === 3) {
            methodTwo.value = '2:2'
        } else {
            methodTwo.value = 'Third Class'
        }
    }

    if (methodOne.value === 1 || methodOne.value === 2 || methodOne.value === 3 || methodOne.value === 4) {
        if(methodOne.value === 1) {
            methodOne.value = 'First Class'
        } else if (methodOne.value === 2) {
            methodOne.value = '2:1'
        } else if (methodOne.value === 3) {
            methodOne.value = '2:2'
        } else {
            methodOne.value = 'Third Class'
        }
    }

    if(weightedAvClassTitle.value === "120 credits required for level 5 & 6" || weightedAvClassTitle.value === "120 credits required" || weightedAvClassTitle.value === 'Incalculable') {
        circleScore.value = 100
    } else if (methodSwitch.value === false || lessThanOneTwenty === true) {
        circleScore.value = 100
        finalScore.value = levelSixFinalGrade.value
    } else {
        circleScore.value = 100
        finalScore.value = weightedAvClass.value 
    }

                
    return { LvFiveCreditsToNum, lvFiveCreditMarkMultiplyer, lvFiveMultiplyerSum, LvSixCreditsToNum, lvSixCreditMarkMultiplyer, lvSixMultiplyerSum }

    /////////////////////////////// Code Block Ends
}





return { 
    methodSwitch,
    visibleClassSix,
    lessThanOneTwentyToggle,
    handlerSubmitUndergrad,
    changeMenu,
    onIntersection,
    gradeSwitch,
    calculated,
    firstClassCredits,
    secondOneClassCredits, 
    secondTwoClassCredits, 
    thirdClass,
    methodOne,
    methodTwo,
    visibleClassFive,
    finalScore,
    // LEVEL FIVE
    levelFiveFinalGrade, 
    LvFiveTwentyFivePercent,
    // LEVEL SIX
    levelSixFinalGrade, 
    LvSixSeventyFivePercent,
    ////////////////////////
    postGradResults,
    circleScore,
    weightedAvClass,
    component,
    getScrollTarget,
    visible,
    LvSixOneHundredPercent,
    resultsClassOnOff,
    router,
    heroLevel,
    sessionMemory,
    weightedAvClassTitle,

}
}
}  
</script>

<style scoped>

</style>